export default "__VITE_ASSET__CAEqk48F__"